import Measured from './Measured';
import { connect } from 'react-redux';
import { makeGetPrevLoadDims } from './redux/selectors';
import { updateMeasuredCookie } from './redux/actions';
const withCookie = (props)=>props.cookieType !== undefined && props.cookieDim !== undefined;
const makeMapStateToProps = ()=>{
    const getPrevLoadDims = makeGetPrevLoadDims();
    return (state, ownProps)=>{
        if (!withCookie(ownProps)) {
            return {};
        }
        return {
            prevLoadDims: getPrevLoadDims(state, ownProps.cookieType, ownProps.cookieDim)
        };
    };
};
const mapDispatchToProps = (dispatch, ownProps)=>({
        onUpdatedDims: (size)=>{
            withCookie(ownProps) && dispatch(updateMeasuredCookie(ownProps.cookieType, ownProps.cookieDim, size));
        }
    });
const container = connect(makeMapStateToProps, mapDispatchToProps);
export const MeasuredCookieConnector = (component)=>// this is a typing hack because TS got really confused by redux generics
    container(component);
/** @deprecated */ const MeasuredContainer = MeasuredCookieConnector(Measured);
MeasuredContainer.displayName = 'MeasuredContainer';
export default MeasuredContainer;
